import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Box } from "@mui/material";

const gifList = [
  "https://media.giphy.com/media/3ormFEYnZ1Mf71p5Uf/giphy.gif",
  "https://media.giphy.com/media/9Q9XWJHXHF360Wxe5i/giphy.gif",
  "https://media.giphy.com/media/ZGCYwUr3If4qnoBimH/giphy.gif",
  "https://media.giphy.com/media/h8iq4ixADtdSJffF85/giphy.gif",
  "https://media.giphy.com/media/sbvsasiEpIrlUUSsPl/giphy.gif",
  "https://media.giphy.com/media/bbogRddP3AL9mNcg7z/giphy.gif",
  "https://media.giphy.com/media/drpTEUUS2adc1Yntav/giphy.gif",
  "https://media.giphy.com/media/i3ikTII6meFRXAMM1Z/giphy.gif",
];

const NotFoundPage = () => {
  const navigate = useNavigate();

  // Nur einmal beim ersten Rendern zufälliges GIF auswählen
  const randomGif = useMemo(() => {
    const index = Math.floor(Math.random() * gifList.length);
    return gifList[index];
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        p: 2,
      }}
    >
      <Box mb={4}>
        <img
          src={randomGif}
          alt="Tennis Fail"
          style={{ maxWidth: "100%", borderRadius: "12px" }}
        />
      </Box>

      <Typography variant="h3" gutterBottom>
        Seite nicht gefunden
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        Die Seite, die du suchst, gibt es nicht (mehr). Vielleicht bist du über einen alten oder unvollständigen Link hier gelandet.
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={4}>
        Überprüfe den Link, den du aufrufen wolltest. Enthält er alle Informationen aus dem QR-Code?
      </Typography>
    </Box>
  );
};

export default NotFoundPage;
